import { z } from 'zod';
import { LenderIdSchema } from '../../lender/general.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const financingServiceConfigSchema = serviceConfigSchema.extend({
    lenderConfigs: z
        .record(LenderIdSchema, z.object({
        dealerId: z.string().optional(),
    }))
        .optional(),
});
// ============================================================================
// DTO Schema
// ============================================================================
const financingServiceConfigDtoSchema = serviceConfigSchema.extend({
    lenderConfigs: z
        .record(LenderIdSchema, z.object({
        dealerId: z.string().optional(),
    }))
        .optional(),
});

export { financingServiceConfigDtoSchema, financingServiceConfigSchema };
//# sourceMappingURL=FinancingServiceConfig.js.map
